import { useEffect, useState } from 'react';

/**
 * Subscribe to a media query from JS.
 *
 * Needed where a breakpoint changes *behaviour*, not just styling — CSS can hide
 * the peek pane below xl, but only JS can decide that a row click should open the
 * profile modal instead of a pane that will never be visible.
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const list = window.matchMedia(query);
    const onChange = (event) => setMatches(event.matches);
    setMatches(list.matches);
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
